import moment from 'moment-timezone';

export default {
  global: {
    useUTC: true,
    getTimezoneOffset: function(time) {
      return 0 - moment.tz(time, 'Europe/Oslo').utcOffset();
    },
  },
  lang: {
    loading: 'Loading...',
    months: [
      'januar',
      'februar',
      'mars',
      'april',
      'mai',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'desember',
    ],
    shortMonths: [
      'jan',
      'feb',
      'mar',
      'apr',
      'mai',
      'jun',
      'jul',
      'aug',
      'sep',
      'okt',
      'nov',
      'des',
    ],
    weekdays: [
      'Søndag',
      'Mandag',
      'Tirsdag',
      'Onsdag',
      'Torsdag',
      'Fredag',
      'Lørdag',
    ],
    decimalPoint: ',',
    rangeSelectorZoom: 'Historisk periode',
    resetZoom: 'Reset zoom',
    resetZoomTitle: 'Reset zoom til 1:1',
    thousandsSep: ' ',
  },
};
